var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { blockEditActions } from './types';
export var defaultBlockEditState = {
    isSaving: false,
    enabled: false,
    dragDisabled: 0,
    savingMessage: '',
    savingError: '',
    data: null
};
export var blockEditReducer = function (state, action) {
    switch (action.type) {
        case blockEditActions.ADD:
            return __assign(__assign({}, state), { data: __assign({}, action.block) });
        case blockEditActions.REMOVE:
            return __assign(__assign({}, state), { data: null });
        case blockEditActions.CLEAR:
            return __assign({}, state);
        case blockEditActions.SAVING:
            return __assign(__assign({}, state), { isSaving: action.isSaving });
        case blockEditActions.TOGGLE_EDIT:
            return __assign(__assign({}, state), { enabled: action.enabled });
        case blockEditActions.TOGGLE_DRAG:
            return __assign(__assign({}, state), { dragDisabled: state.dragDisabled + action.drag });
        case blockEditActions.RESET:
            return __assign(__assign({}, state), defaultBlockEditState);
        default:
            throw new Error("Unhandled action: " + action);
    }
};
